import React from "react";
import { SecondaryButton } from "../../../globalComponents/ui/Button";
import { SettingsEmptyState } from "../../Settings/SettingShell";

/** Sticky column-header cell. */
export const ColHeader = ({ children, width, flex }) => (
  <div style={{
    ...(width ? { width, flexShrink: 0 } : {}),
    ...(flex ? { flex } : {}),
    padding: "0 10px",
    fontSize: 10,
    fontWeight: 700,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    whiteSpace: "nowrap",
  }}>
    {children}
  </div>
);

/** Hover/zebra row shell shared by every Evidence Library list row. */
export const ListRow = ({ index, onClick, children }) => {
  const base = index % 2 === 0 ? "#ffffff" : "#f8fafd";
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        cursor: onClick ? "pointer" : "default",
        background: base,
        borderBottom: "1px solid #eef1f5",
        transition: "background .12s",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "#eef6fb"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = base; }}
    >
      {children}
    </div>
  );
};

/**
 * Shared list chrome (sticky column header, loading/error/empty states,
 * footer) reused by both the Evidences and Uploaded Documents tabs — modeled
 * on QuantativeList.jsx's rounded-card list.
 */
const EvidenceListView = ({
  columns,
  rows,
  rowKey,
  renderRow,
  isLoading,
  error,
  onRetry,
  emptyTitle = "No results found",
  emptySub,
  footer,
}) => (
  <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
    <div style={{ display: "flex", alignItems: "center", padding: "10px 16px", background: "#f8fafc", borderBottom: "2px solid #e5e8ed" }}>
      {columns.map((c) => <ColHeader key={c.key} width={c.width} flex={c.flex}>{c.label}</ColHeader>)}
    </div>

    {isLoading ? (
      <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>Loading…</div>
    ) : error ? (
      <div style={{ padding: 40, textAlign: "center" }}>
        <div style={{ color: "#dc2626", fontWeight: 700, marginBottom: 10, fontSize: 13 }}>Failed to load data</div>
        {onRetry && <SecondaryButton onClick={onRetry}>Retry</SecondaryButton>}
      </div>
    ) : rows.length === 0 ? (
      <SettingsEmptyState>
        <i className="fas fa-file-alt s-empty-icon" />
        <div className="s-empty-title">{emptyTitle}</div>
        {emptySub && <div className="s-empty-sub">{emptySub}</div>}
      </SettingsEmptyState>
    ) : (
      rows.map((row, i) => <React.Fragment key={rowKey(row)}>{renderRow(row, i)}</React.Fragment>)
    )}

    {footer && !isLoading && !error && rows.length > 0 && (
      <div style={{ padding: "10px 16px", borderTop: "1px solid #eef1f5", background: "#f8f9fb", fontSize: 11.5, color: "#94a3b8", display: "flex", justifyContent: "space-between" }}>
        {footer}
      </div>
    )}
  </div>
);

export default EvidenceListView;
